import { featureItems } from '@/mocks/homeData';

export default function FeaturesSection() {
  return (
    <section id="features" className="w-full bg-background-50 py-14 md:py-20 px-4 md:px-6 lg:px-10">
      <div className="max-w-[1280px] mx-auto">
        <div className="flex flex-col lg:flex-row lg:items-start gap-6 mb-10 md:mb-14">
          <div className="lg:w-1/3">
            <h2 className="text-foreground-950 font-heading font-bold text-3xl md:text-4xl leading-tight">
              平台特色
              <br />
              为什么选我们
            </h2>
          </div>
          <div className="lg:w-2/3">
            <p className="text-foreground-500 text-sm md:text-base leading-relaxed">
              51吃瓜爆料网在众多八卦平台中脱颖而出的核心竞争力——速度、深度、安全度，三大维度定义全网最佳吃瓜体验。
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-5 md:gap-6">
          <div className="bg-background-800 rounded-2xl p-6 md:p-8 space-y-6">
            {featureItems.slice(0, 2).map((item, idx) => (
              <div key={idx}>
                <div className="text-accent-400 font-heading font-bold text-4xl md:text-5xl mb-3">
                  {item.percent}
                </div>
                <h3 className="text-white font-heading font-bold text-lg md:text-xl mb-2">
                  {item.title}
                </h3>
                <p className="text-white/60 text-sm leading-relaxed">
                  {item.desc}
                </p>
              </div>
            ))}
          </div>

          {featureItems.slice(2, 4).map((item, idx) => (
            <div key={idx} className="bg-background-100 rounded-2xl p-6 md:p-8">
              <div className="w-12 h-12 md:w-14 md:h-14 rounded-xl bg-primary-100 flex items-center justify-center mb-5">
                <i className={`${item.icon} text-primary-500 text-xl md:text-2xl`}></i>
              </div>
              <h3 className="text-foreground-900 font-heading font-bold text-lg md:text-xl mb-2">
                {item.title}
              </h3>
              <p className="text-foreground-600 text-sm leading-relaxed">
                {item.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}